import {writable} from "svelte/store";
export const isOtherItemDraggingStore=writable(false);